module.exports = __webpack_public_path__ + "img/Number=94.caac9834.png";